// extracted by mini-css-extract-plugin
module.exports = {"marque":"client_marque__cMrY1","marqueTrack":"client_marqueTrack__ipMda","marquee":"client_marquee__fPwud","marqueInner":"client_marqueInner__ZvjLI"};